<template>
  <div class="gameplan">
    <el-dialog  top="5vh" title="选择" :visible.sync="dialog" width="750px"
      :close-on-click-modal="false">
      <div v-loading="dialogLoading">
        <div v-if="themeList.length>0">
          <div class="pr-box  is_hover_shadow" v-for="item of themeList" :key="item.themeId">
              <div class="space-between">
                <div class="pr-title"> {{item.themeName}} <span class="pr-level">{{ getOrgLevel(item.orgLevel) }}</span> </div>
                <!-- <div class="pr-status"> {{getThemeStatus(themeDetailStatus)}} </div> -->
              </div>
              <div class="pr-item-flex">
                <div style="margin-top:12px;"><span class="font-weight-bold">PR信息：</span>{{getItemInfo(item.gpPrDTOList,'pr')}}</div>
              </div>
              <div class="pr-item-flex">
                <div style="margin:12px 0;"><span class="font-weight-bold">品牌信息：</span>{{ getItemInfo(item.gpPrDTOList,'brand') }}</div>
              </div>
              <!-- <div class="pr-item">
                <div> 活动时间： {{ item.themeStartTime | parseTime("{y}-{m}-{d}") }} {{item.themeStartTime?'-':''}}  {{ item.themeEndTime | parseTime("{y}-{m}-{d}") }} </div>
              </div> -->
              <div class="pr-item space-between">
                <div> <span class="font-weight-bold">活动时间：</span> {{ item.themeStartTime | parseTime("{y}-{m}-{d}") }} {{item.themeStartTime?'-':''}}  {{ item.themeEndTime | parseTime("{y}-{m}-{d}") }} </div>
                <!-- <div> 已配置活动：{{ item.totalQty || 0 }} &ensp; 已提报场次：{{ item.submitQty || 0 }}</div> -->
                <div class="operation_btn_box">
                  <div class="operate_btn operate_btn_red"  @click="gotoConfig(item.themeId)">选择</div>
                </div>
              </div>
          </div>
        </div>
        <div v-else class="no-data">暂无数据</div>
        <div class="pagination">
          <el-pagination background :total="total" layout="total, prev, pager, next" :current-page="queryParams.page"
            :page-size="queryParams.pageSize" @current-change="handleCurrentChange" @size-change="handleSizeChange" />
        </div>
      </div>


      <span slot="footer" class="dialog-footer">
        <!-- <el-button  style="margin-right:20px" size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button  size="small" type="danger" @click="beSure()">确 定</el-button> -->
      </span>
    </el-dialog>

  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import gameplanApi from "@/api/gameplan";
export default {
  name: 'activity-management',
  data() {
    return {
      loading:false,
      dialogLoading:false,
      queryParams: {
        page: 1,
        pageSize: 5,
        // queryCondition:'03,05',
        // prNumber: '', // PR编码
        // prName:'', // PR名称
        // brandCode: '', // 选择品牌
      },
      themeList:[],
      total:0,
      dialog:false,
      item:{}
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created() {
    this.getGameplanThemeList()
  },
  methods: {
    handleShow(themeId){
      this.themeId = themeId
      this.dialog = true
    },
    async getGameplanThemeList(page,pageSize) {
      this.dialogLoading = true
      page?this.queryParams.page=page:''
      pageSize?this.queryParams.pageSize=pageSize:''
      const { data } = await gameplanApi.getGameplanThemeList(this.queryParams);
      if (data.resultCode === "0") {
        this.themeList = data.resultData?.themeList || [];
        this.total = data.resultData.pageInfo.totalCounts
      }
      this.dialogLoading = false
    },
    getItemInfo(gpPrDTOList,type){
      let brandInfo = []
      let prInfo = []
      if(gpPrDTOList){
        gpPrDTOList.forEach(item=>{
          let data = ''
          if(type==='pr') prInfo.push(item.prNumber+'-'+item.prName)
          else {
            if(item.brandName&&item.subBrandName)  data = item.brandName+'-'+item.subBrandName
            else data = item.brandName||item.subBrandName
            if(brandInfo.indexOf(data)===-1) {
              brandInfo.push(data)
            }
          }
        })
      }
      if(type==='pr') return prInfo.join('、')
      else return brandInfo.join('、')
    },
    getOrgLevel(orgLevel){
      if(orgLevel&&orgLevel.length===2) return orgLevel.toUpperCase()
      else return 'Region'
    },
    handleCurrentChange(val) {
      this.queryParams.page = val
      this.getGameplanThemeList()
    },
    handleSizeChange (val) {
      this.queryParams.pageSize = val
      this.getGameplanThemeList()
    },
    gotoConfig(historyThemeId){
      this.$router.push({ name:'configure-theme-detail', query:{historyThemeId:historyThemeId,themeId:this.themeId}})
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog{
  margin: 0 auto 15px;
}
::v-deep .el-dialog__body {
  overflow: auto;
  max-height: 60vh;
}
::v-deep .el-pagination{
  text-align: center;
  margin-top: 20px;
}
.no-data{
  text-align: center;
  padding: 20px 0;
}
.is-hover-shadow:hover {
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
}

.trade-nav-panel {
  width: 80%;
  margin: 0 auto;
  background: $base-white;

  //   .el-menu-item:last-child{
  //     border-bottom: 0;
  //   }
  ::v-deep .el-card__header {
    height: 70px;
    line-height: 35px;
  }

  ::v-deep .el-card__body {
    padding: 0;
  }

  .panel-header {
    font-size: 16px;
    font-weight: 700;
    color: #CD1231;
  }

  ::v-deep .el-menu {
    border-right: 0;
  }

  ::v-deep .el-menu-item {
    border-bottom: 1px solid $base-grey5;
  }

  ::v-deep .el-menu-item.is-active {
    color: $base-red;
  }
}
.content-wrapper {
  min-height: calc(100vh - 320px) !important;
  font-family: SourceHanSansSC-regular;
  //   .content-left,
  .content-right {
    height: 100%;
    box-sizing: border-box;
    a {
      text-decoration: none;
      color: #000;
    }

    .search {
      display: flex;
      justify-content: space-between;
      width: 100%;

      .item {
        width: 120px;
      }
      .item-btn {
        margin-left: 30px;
      }
    }

    .pagination {
      position: relative;
      bottom: 0;
    }
  }
.pagination .el-pagination {
  text-align: center;
}
  .content-left {
    padding-right: $content-middle;
  }
}

.pr_item{
  ::v-deep .el-card__body{
      padding: 15px;
    }
}

.block{
  //margin-top: 20px;
  //background-color: rgba(0, 0, 0, 1);
  width: 100%;
  height: 30px;
}
.trade-nav-panel-sp{
  margin-top: 30px;
}
.no_data{
  text-align: center;
  padding: 100px 0;
}
.border_grey{
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
}


.pr-box{
  margin-bottom: 15px;
  padding: 15px 10px 5px 10px;
  background-color: #ffffff;
  border-radius: 8px;
  border: solid 1px #efefef;
  .pr-item{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 12px;
  }
  .space-between{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .flex-end{
    justify-content:flex-end;
  }
  .pr-title{
    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
    width: 800px;
    word-wrap: break-word;
  }
  .pr-level{
    color: white;
    //display: inline-block;
    font-size: 14px;
    line-height: 24px;
    padding: 0 10px;
    background-color: rgb(71, 172, 255);
  }
  .pr-status {
    color: rgb(192, 1, 1);
    font-size: 16px;
    font-weight: 600;
  }
  .operation_btn_box{
    display: flex;
    .operate_btn{
      text-align: center;
      padding: 5px 12px;
      border-radius: 4px;
      margin: -5px 0  0 10px;
      cursor: pointer;
    }
    .operate_btn_red {
      color: white;
      background-color: rgb(214, 0, 0);
    }
    .operate_btn_white{
      color: rgb(214, 0, 0);
      background-color: white;
      border: 1px solid rgb(214, 0, 0);
    }
  }
}
.pr-item-flex{
  display:flex;
  flex-wrap:wrap;
}
.font-weight-bold{
  font-weight: bold;
}
</style>
